/**
 * Scene writing room (#857). One instruction. No silent winner.
 * The book you open is the book this scene belongs to.
 */
export function sceneWritingPath(storyId) {
  return storyId ? `/scene-writing/${storyId}` : '/scene-writing';
}

/**
 * The book already on screen. Write uses this so the first click
 * after a book opens does not wait on currentStory alone.
 * A bible template key is not a book id.
 */
export function sceneWritingBookId({ pathname = '', currentStory, currentSession } = {}) {
  const path = pathname || '';
  const patterns = [
    /^\/scene-writing\/([^/]+)/,
    /^\/plottrack\/([^/]+)/,
    /^\/style-cards\/([^/]+)/,
    /^\/(?:tasks|path)\/([^/]+)/,
    /^\/story-rules\/([^/]+)/,
    /^\/projects\/[^/]+\/stories\/([^/]+)\/notes\/?$/,
  ];
  for (let i = 0; i < patterns.length; i += 1) {
    const match = path.match(patterns[i]);
    if (match?.[1]) return match[1];
  }
  if (path.startsWith('/chat/') && currentSession?.story_id) return currentSession.story_id;
  return currentStory?.id || currentSession?.story_id || null;
}

export function sceneWritingPathForBook(ctx) {
  return sceneWritingPath(sceneWritingBookId(ctx));
}

/**
 * Plot Grid → Scene Writing handoff (#1118). Scene, title, and
 * viewpoint travel on the URL so first paint keeps the selected cell.
 */
export function draftThisScenePath(storyId, { sceneId, title, viewpoint } = {}) {
  const base = sceneWritingPath(storyId);
  const params = new URLSearchParams();
  if (sceneId) params.set('scene', sceneId);
  if (title) params.set('title', title);
  if (viewpoint) params.set('viewpoint', viewpoint);
  const query = params.toString();
  return query ? `${base}?${query}` : base;
}

const SCENE_LABEL = /^\d+\.\d+$/;

/** A Plot Grid number such as 1.3 is a scene label, not an id. */
export function sceneAddress(value) {
  const text = String(value || '').trim();
  if (SCENE_LABEL.test(text)) return { id: '', label: text };
  return { id: text, label: '' };
}

export function isRawSceneError(message) {
  const text = String(message || '');
  return /uuid/i.test(text) || /input should be a valid/i.test(text);
}

export function sceneWritingHandoffFromSearch(searchParams) {
  if (!searchParams) return { sceneId: '', title: '', viewpoint: '' };
  return {
    sceneId: searchParams.get('scene') || '',
    title: searchParams.get('title') || '',
    viewpoint: searchParams.get('viewpoint') || '',
  };
}
